<template>
    <div class="coupon-table">
        <div class="itemlist" v-for="user in users">
            <div class="item">
                <span>{{ user.name }}</span>
                <span>{{ user.nickName }}</span>
            </div>
            <div class="item">
                <span>核销时间：{{ user.useTime }}</span>
                <!-- <span>{{ users.nickName }}</span> -->
            </div>
        </div>

    </div>
</template>

<script>
import { getCouponSendRecord } from "@/services/task";
export default {
    data() {
        return {
            users: []
        }
    },

    mounted() {
        this.list();
    },
    methods: {
        list() {
            getCouponSendRecord().then(res => {
                this.users = res.data;
            })
        }
    }
};
</script>

<style lang="less" scoped>
.coupon-table {
    width: 100%;
    height: 98vh;
    background-color: #F7F8FC;
    padding-top: 20px;
    overflow: hidden;
    overflow-y: auto;
}

.itemlist {
    margin: 10px;
    padding: 10px;
    background-color: #ffffff;
    border-radius: 10px;
}

.item {
    display: flex;
    justify-content: space-between;
    font-weight: 400;
    font-size: 12px;
    color: #333333;
}

.item:first-child {
    font-weight: 600;
    font-size: 14px;
    color: #333333;
    margin-bottom: 5px;
}
</style>
